import {
  EDischargeTypes,
  EVehicleTypes,
  EWeekDays,
  IDayAndTimeToReceive,
  IFabricationContract,
  IResponsibleOfConstruction
} from '../fabrication-contracts/types';

// Action Types
export enum Types {
  UPDATE_CONTRUCTION_REGISTRATION_SETTINGS = 'contractsAndConstructions/UPDATE_CONTRUCTION_REGISTRATION_SETTINGS',

  FINISH_CONSTRUCTION_REGISTRATION = 'contractsAndConstructions/FINISH_CONSTRUCTION_REGISTRATION',
  FINISH_CONSTRUCTION_REGISTRATION_SUCCESS = 'contractsAndConstructions/FINISH_CONSTRUCTION_REGISTRATION_SUCCESS',
  FINISH_CONSTRUCTION_REGISTRATION_FAILURE = 'contractsAndConstructions/FINISH_CONSTRUCTION_REGISTRATION_FAILURE',

  LOAD_CUSTOMER_CONTRACTS = 'contractsAndConstructions/LOAD_CUSTOMER_CONTRACTS',
  LOAD_CUSTOMER_CONTRACTS_V2 = 'contractsAndConstructions/LOAD_CUSTOMER_CONTRACTS_V2',
  LOAD_CUSTOMER_CONTRACTS_SUCCESS = 'contractsAndConstructions/LOAD_CUSTOMER_CONTRACTS_SUCCESS',
  LOAD_CUSTOMER_CONTRACTS_FAILURE = 'contractsAndConstructions/LOAD_CUSTOMER_CONTRACTS_FAILURE',

  SET_HIGHLIGHT_NEW_CONTRACTS = 'contractsAndConstructions/SET_HIGHLIGHT_NEW_CONTRACTS',

  CLEAR_CONTRUCTION_REGISTRATION_SETTINGS = 'contractsAndConstructions/CLEAR_CONTRUCTION_REGISTRATION_SETTINGS',

  CLEAR_CONTRACTS_AND_CONSTRUCTIONS_STATE = 'contractsAndConstructions/CLEAR_CONTRACTS_AND_CONSTRUCTIONS_STATE',

  OPEN_NEW_CONSTRUCTION_MODAL = 'OPEN_NEW_CONSTRUCTION_MODAL',
  CLOSE_NEW_CONSTRUCTION_MODAL = 'CLOSE_NEW_CONSTRUCTION_MODAL'
}

export interface IContractsAndConstructionsState {
  contractsManager: IContractsManagerState;
  constructionRegistration: IConstructionRegistrationState;
  canShowNewConstructionModal: boolean;
}

export interface IContractsManagerState {
  loading: boolean;
  error: boolean;
  bpError?: boolean;

  customerContracts: IFabricationContract[];
  selectedCustomerId?: string;
  highlightNewContracts: boolean;
}

export interface IConstructionRegistrationState {
  contractNumber: string;

  constructionData?: IConstructionData;
  deliveryConditions?: IDeliveryConditions;
  responsiblesOfConstruction: IResponsibleOfConstruction[];

  loading: boolean;
  error: boolean;
  success: boolean;
}

// Tipagem para a tela de Dados da obra no cadastro de obra
export interface IConstructionData {
  customerId: string;
  emitterCNPJ: string;
  receiverCNPJ: string;
  stateRegistration: string;
  constructionName: string;

  address: {
    address: string;
    state: string;
    city: string;
    cep: string;

    complement: string;
    towerOption: ETowerOption; // dados novos para receber novo modelo de torres
    towers?: string[]; // dados novos para receber novo modelo de torres
  };
}

// Tipagem para a tela de Condições de entrega no cadastro de obra
export interface IDeliveryConditions {
  allowedDaysAndTimeToReceive: IDayAndTimeToReceive[];
  allowedVehicleTypes: EVehicleTypes[];
  allowedDischargeType: EDischargeTypes;
  dischargeObservation: string;
}

export const DEFAULT_DELIVERY_CONDITIONS: IDeliveryConditions = {
  allowedDaysAndTimeToReceive: Object.values(EWeekDays).map((day) => {
    return {
      day,
      checked: day !== EWeekDays.SUNDAY && day !== EWeekDays.SATURDAY
    };
  }),
  allowedVehicleTypes: [],
  allowedDischargeType: EDischargeTypes.MANUAL,
  dischargeObservation: ''
};

export const DEFAULT_RESPONSIBLE_OF_CONSTRUCTION: IResponsibleOfConstruction = {
  name: '',
  email: '',
  phoneNumber: '',
  jobTitle: ''
};

export const INITIAL_CONSTRUCTION_REGISTRATION: IConstructionRegistrationState =
  {
    contractNumber: '',
    responsiblesOfConstruction: [DEFAULT_RESPONSIBLE_OF_CONSTRUCTION],
    loading: false,
    error: false,
    success: false
  };

// remover LETTERS quando remover o toggle
export enum ETowerOption {
  UNIQUE = 1,
  NUMBERS_OR_LETTERS = 2,
  LETTERS = 3
}
